import EventRef from '../../models/EventRef';
import HttpAbstract from './AbstractHttp';

const ROUTE = process.env.REACT_APP_URL_API_EVENT_REFS;
export default class EventRefHttp extends HttpAbstract<EventRef> {
  constructor() {
    super(`${ROUTE}`, EventRef);
  }
}
